// extracted by mini-css-extract-plugin
module.exports = {"TicketExpiration":"TicketExpiration_TicketExpiration__1e7Gx","TicketExpiration__Emphasis":"TicketExpiration_TicketExpiration__Emphasis__1A89u"};